import { IconProductDocumentsVerified12, Label } from '@cian/ui-kit';

import { type FC } from 'react';

export const FromOwnerCheckedLabelContainer: FC = () => {
  return (
    <Label
      background="surface-positive-default"
      color="text-positive-default"
      data-testid="publisher-labels.from-owner-checked"
      icon={<IconProductDocumentsVerified12 />}
    >
      Собственник
    </Label>
  );
};
